<template>
    <page-header></page-header>
        <section class="vh-form gradient-custom">
            <div class="container py-5 h-100">
                <div class="row d-flex justify-content-center align-items-center h-100">
                    <div class="col-12 col-md-8 col-lg-6 col-xl-7">
                        <div id="form-container" class="card bg-dark text-white" style="border-radius: 1rem; margin-bottom: 20%;">
                            <div class="card-body p-5 text-center">

                                <div class="mt-md-4">

                                    <h2 title="Status Email Opt-Out" class="fw-bold mb-2 text-uppercase">Parcel Notification Email Opt-Out</h2>

                                    <div id="pre-request">
                                      <p class="text-white-50 mb-5"> Unsubscribe from all future Parcel Notification emails by moving the slider to the right and clicking submit.</p>

                                      <div class="form-check form-switch mb-4">
                                          <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" @change="onChange">
                                          <label class="form-check-label" for="flexSwitchCheckDefault">Unsubscribe</label>
                                      </div>

                                      <div style="display:none !important;" id="wheel-container" class="d-flex justify-content-center">
                                        <div class="spinner-border text-warning yellow-wheel info-spinner" role="status"></div>
                                      </div>

                                      <button id="submitBtn" class="btn btn-outline-light btn-lg px-5" type="submit" v-on:click="submit" disabled>Submit</button>
                                      <br>
                                      <br>
                                    </div>

                                    <div id="success-request" style="display:none;">
                                      <p class="text-white-50 mb-5"> You have been successfully opted out of all future Parcel Notification emails.</p>
                                      <br>
                                      <br>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <page-footer></page-footer>
</template>

<script>
import PageHeader from "./PageHeader.vue";
import PageFooter from "./PageFooter.vue";
import axios from "axios";
import { parcel_api } from '@/js_utils/urls.js';

export default {
  name: "EmailOptOut",
  components: {
    PageHeader,
    PageFooter,
  },
  methods : {
    onKeyPress: function(e){
      if (e.keyCode === 13){
        this.submit(e);
      }
    },
    submit : function(e){
        e.preventDefault();
        window.removeEventListener('keypress', this.onKeyPress);

        //Display loading wheel
        document.getElementById("wheel-container").style.display = "flex";

        let request_payload = {
          "account_id": this.$route.params.accountid
        }

        axios.post(parcel_api + "/opt-out", request_payload)
        .then(response => {
          console.log(response)

          document.getElementById("pre-request").style.cssText = "display:none !important";
          document.getElementById("success-request").style.display = "block";

        })
        .catch(error => {
          console.log(error)
        })
    },
    onChange : function(){
      var isChecked = document.getElementById("flexSwitchCheckDefault").checked;
      
      if(isChecked){
        document.getElementById("submitBtn").disabled = false;
      }
      else{
        document.getElementById("submitBtn").disabled = true;
      }
    }
  },
  beforeMount() {
    scroll(0, 0);
  },
  mounted(){
    window.addEventListener('keypress', this.onKeyPress);
  }
};
</script>